import React, { Component } from 'react';
import { Row } from "antd";
import Table1 from './3-3-1';
import Table2 from './3-3-2';
import Table3 from './3-3-3';

class index extends Component {
    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    6.2 F&B Catering/Banquet KPI Analysis 餐饮部宴会活动关键绩效指数分析
                </Row>
                <Table1></Table1>
                <Table2></Table2>
                <Table3></Table3>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-3/index.js